<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="terms-of-service">
      <Title jpn="服務條款" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">關於Xero Place Co., Ltd.（以下簡稱「本公司」）在本網站上提供的服務（以下簡稱「服務」）以及本公司與服務使用者之間的權利和義務關係的條款和條件，在網站使用條款（包括本公司作為合約內容另行規定的任何其他規定；以下簡稱「條款」）中規定如下。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第一條（術語定義）</span>
            <span class="text">本條款中下列各項中術語的涵義應依各項規定。</span>
            <span class="text">(1) 「本公司」指提供本服務的Xero Place Co., Ltd.。</span>
            <span class="text">(2) 「本網站」指本公司提供的網站
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              。</span>
            <span class="text">(3)「條款」是指服務使用者必須遵守的規定。</span>
            <span class="text">(4) 「服務使用協議」指有關服務使用的合約。</span>
            <span class="text">(5) 「服務使用者」係指與本公司簽訂服務使用合約的人。</span>
            <span class="text">(6) 「帳戶」指服務使用者在本服務中註冊的與服務使用者相關的資訊。</span>
            <span class="text">(7) 「密碼」係指由客戶創建的字母數字字元組合所組成的代碼。</span>
            <span class="text">(8) 「電子郵件地址」係指服務使用者在本服務中註冊的電子郵件地址。</span>
            <span class="text">(9) 「貨幣」是指可以在本網站內使用的虛擬貨幣。</span>
            <span class="text">(10)「產品」是指可以透過本網站的遊戲獲得的卡牌。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二條（適用範圍）</span>
            <span class="text">1 服務使用者必須依照本條款的規定使用本網站，除非同意本條款，否則不能使用本網站。</span>
            <span class="text">2 服務使用者在本網站的註冊畫面上完成同意本條款的手續後，服務利用者與本公司之間將建立符合本條款規定的使用合約（以下簡稱「使用協議」），本條款的內容將成為服務使用者與本公司之間的合約內容。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第3條（服務內容等）</span>
            <span class="text">1 本服務的內容及使用流程詳見使用指南。</span>
            <span class="text">2 本公司可隨時自行決定變更本服務的內容或終止提供本服務。</span>
            <span class="text">3 服務使用者不得對本公司變更服務內容或終止提供服務提出異議，或提出任何損害賠償或其他索賠要求。</span>
            <span class="text">4 若終止提供本服務，應依本公司規定的方式提前通知使用者。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第四條（使用申請）</span>
            <span class="text">1 若您希望使用本服務，您必須造訪本網站，同意本使用條款，並申請使用本服務（以下簡稱「服務使用申請」）。</span>
            <span class="text">2 當本公司接受服務使用申請時，本公司與服務使用申請者（以下簡稱「服務使用申請人」）之間將依本條款簽訂服務使用合約。</span>
            <span class="text">3 如果希望使用本網站的人是未成年人等，則在使用本網站之前必須事先獲得父母或監護人等法定代表人的同意。若未成年人等同意本條款，則視為已取得其法定代理人的同意，我們不承擔任何責任。</span>
            <span class="text">4 我公司可能不接受您的服務使用申請。在此情況下，本公司沒有義務揭露原因。</span>
            <span class="text">5 服務使用申請人在申請使用服務時不得提交不準確或虛假的資訊。</span>
            <span class="text">6 即使因帳戶資訊錯誤、變更延遲或其他瑕疵而導致本服務的使用出現問題，本公司也不對此承擔責任。</span>
            <span class="text">7 本條款和 Coin 使用條款是公司與服務使用者之間關於使用
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              上由本公司策劃、開發和營運的付費服務的協議。</span>
            <span class="text">8 所有使用付費服務的使用者均應遵守本協議的條款和條件。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第五條（服務利用者解除服務使用契約）</span>
            <span class="text">服務使用者可以隨時依照本服務上的取消程序或本公司另行規定的其他取消程序取消服務使用合約。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第六條（註冊使用本服務）</span>
            <span class="text">1 服務使用者必須自費並負責準備服務使用者使用本服務所需的終端、通訊設備、軟體、連接網際網路的合約等。</span>
            <span class="text">2 本公司對服務使用者使用本服務的環境不存在任何參與，也不承擔任何責任。</span>
            <span class="text">3 服務使用者可以在註冊時註冊自己的電子郵件地址，並將其用作服務的電子郵件地址。請注意，您無法在網站上更改您的電子郵件地址，因此，如果您註冊時使用了錯誤的電子郵件地址或更改了您的電子郵件地址，我們將在進行更改之前確認您的身分。</span>
            <span class="text">4 服務使用者一般限於每人一個帳戶，禁止擁有多個帳戶。此外，如果本公司發現服務使用者擁有多個帳戶，本公司將刪除該服務使用者擁有的帳戶，恕不另行通知。此時，充入已刪除帳戶的所有硬幣都將被沒收。</span>
            <span class="text">5 若本公司認為本網站的運作有困難，公司可以限制服務使用者使用本服務，直到原因得到解決。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第七條（帳戶管理）</span>
            <span class="text">1 使用者負責註冊和管理其註冊使用的資訊（以下簡稱“註冊資訊”，包括電子郵件地址、ID、密碼等）。用戶不得允許任何第三方使用，亦不得出借、轉讓、更名、買賣等。</span>
            <span class="text">2 若依據註冊資料使用本服務，本公司可視為註冊使用人使用，此使用後果及相關責任由註冊使用人承擔。</span>
            <span class="text">3. 若使用者因未經授權使用註冊資訊而對公司或第三方造成損害的，使用者應賠償公司和第三方的損失。</span>
            <span class="text">4.用戶管理註冊資訊的風險由用戶自行承擔，本公司對因註冊資訊錯誤或虛假而對用戶造成的任何不利或損害不承擔任何責任。</span>
            <span class="text">5、如發現註冊資料被盜用或被第三方使用，使用者應立即通知本公司，並依本公司的指示處理。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第八條（服務使用者的義務）</span>
            <span class="text">1 除非本公司明確許可，服務使用者不得就本服務進行下列任何行為。</span>
            <span class="text">（一）違反法律、法規的行為</span>
            <span class="text">(2) 違反本使用條款的行為</span>
            <span class="text">(3) 對公司或第三方造成不公平的不利或損害的行為</span>
            <span class="text">(4) 將本服務的各項功能用於其他目的</span>
            <span class="text">(5) 以與正常使用本服務時不同的方式使用本服務（包括自動化和抓取）</span>
            <span class="text">(6) 侵犯本公司或第三方的智慧財產權</span>
            <span class="text">(7) 侵害本公司或第三方的隱私權或肖像權</span>
            <span class="text">(8) 洩漏本公司或第三方機密資訊</span>
            <span class="text">(9) 向第三方提供可在服務內查看的信息</span>
            <span class="text">(10) 未經本人同意向第三方提供個人資訊</span>
            <span class="text">(11) 對本公司或第三方的誹謗</span>
            <span class="text">(12) 損害本公司或第三方的名譽或信譽</span>
            <span class="text">(13) 冒充本公司或第三方</span>
            <span class="text">(14) 第三方帳戶資訊的使用</span>
            <span class="text">(15) 竄改或刪除用於提供服務的系統中所記錄的資訊；</span>
            <span class="text">(16) 發送有害的電腦程式等，或根據本公司或第三方的要求提供傳播。</span>
            <span class="text">(17) 其他服務和產品、團體和組織等的廣告、促銷或招攬。</span>
            <span class="text">(18) 幹擾本服務的提供及其他運作</span>
            <span class="text">(19) 傳遞含有電腦病毒或其他有害電腦程式的訊息</span>
            <span class="text">(20) 對用於提供服務的電信設備（包括但不限於伺服器；以下簡稱「電信設備」）造成過度負載的行為。</span>
            <span class="text">(21) 取消或規避用於提供服務的系統中設定的存取控制功能等未經授權的存取。</span>
            <span class="text">(22) 本服務所使用的軟體進行複製、修改、轉載、修改、變更、反向工程、反組譯、反編譯、翻譯或分析。</span>
            <span class="text">(23) 透過欺詐手段（包括所謂的網路釣魚和類似手段）從公司或第三方獲取資訊</span>
            <span class="text">(24) 打電話給我們的時間太長，重複進行類似的詢問，或在沒有義務和理由的情況下強迫我們答覆。</span>
            <span class="text">(25) 透過銷售設備、提供資訊、設定超連結等方式鼓勵上述行為的行為。</span>
            <span class="text">(26) 可能屬於上述各項的行為。</span>
            <span class="text">(27) 其他本公司認為不當的行為（不適當的註冊名稱、重複帳戶、查詢時的評論內容等）</span>
            <span class="text">2 若帳戶資料有變更，服務使用者必須及時登記變更後的資料。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第9條（個人資料的處理）</span>
            <span class="text">服務使用者同意本公司將依照我們的個人資訊保護政策的規定處理其個人資訊。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十條（服務使用者相關資訊的刪除）</span>
            <span class="text">1 若與服務使用者解除服務合同，本公司將刪除該服務使用者的相關資訊（包括但不限於帳戶資訊、應用程式內貨幣、付費服務相關資訊）。</span>
            <span class="text">2 本公司不會恢復依前款規定刪除的服務利用者的資料。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十一條（服務相關權利）</span>
            <span class="text">與本公司透過本服務提供給服務使用者的內容和資訊有關的智慧財產權和其他權利屬於本公司或已授予本公司權利的第三方。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十二條（關於有償服務）</span>
            <span class="text">1 服務使用者可以依照本公司規定的方法，依照本公司在本服務或本公司提供的其他服務中提示的金額，購買只能在本公司提供的服務範圍內使用的硬幣。此外，公司可以為服務使用者設定購買金幣的購買單位、支付方式、使用期限及其他購買條件，所設定的購買條件和應付金額等將在服務內公佈。</span>
            <span class="text">2 Coin 使用條款以及與使用 Coin 相關的其他條件除本使用條款外，還應遵守本網站上發布的 Coin 使用條款。</span>
            <span class="text">3. 服務使用者應依照本公司另行確定的支付方式和條件支付有償服務使用費（包括服務使用者因有償服務而產生的任何其他債務）。任何費用一經支付，本公司將不予退還，除非本公司負有法律責任，例如由於本公司的疏忽。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十三條（關於產品）</span>
            <span class="text">1 服務使用者可以接收透過付費服務獲得的產品的交付。</span>
            <span class="text">2. 服務使用者自購買日起最多可持有所購買的商品24小時（以下簡稱「持有期間」），如需交付，必須在本網站辦理規定的交付手續。</span>
            <span class="text">3 若超過前款規定的保留期限，服務使用者將失去接收該產品的權利。請注意，超過持有期限的產品將自動返回Coin。</span>
            <span class="text">4. 如果因公司的原因導致公司無法交付服務利用者取得的產品，公司將向服務利用者釋放服務利用者用於取得產品的代幣，從而免除公司的損害責任。請注意，本公司沒有義務採購和交付與上述產品相同的產品。</span>
            <span class="text">5 與產品相關的運費將由我們全額負擔。請注意，海外運送可能會收取額外費用。</span>
            <span class="text">6 我們將使用我們的合作夥伴大和運輸有限公司或我們指定的承運商進行送貨。</span>
            <span class="text">7 每月5日、10日、15日、20日、25日、最後一天出貨至我司指定的運輸公司。</span>
            <span class="text">*如果您在上述送貨時間之前或之後使用該服務，則送貨時間可能是下一個或更晚的送貨時間，而不是最近的送貨時間。</span>
            <span class="text">*出貨準備完成後，我們會立即通知您。因此，追蹤號碼可能要到第二天才會反映在網路上。感謝您的體諒。</span>
            <span class="text">8.對於產品運送過程中所出現的損壞等問題，我們不承擔任何責任。</span>
            <span class="text">9 如果在交付產品之前發現服務使用者違反了使用條款，公司可以暫停交付產品。由此造成的損失，本公司不負賠償責任，敬請諒解。</span>
            <span class="text">10 本公司將產品交付給服務使用者後，如果因地址不明等原因導致產品被拒收或退回，且服務使用者未遵循重新發送程序，則服務使用者將失去對該產品的所有權利。即使在這種情況下，公司也沒有義務提供任何補償或損害賠償，例如返還硬幣的義務。</span>
            <span class="text">11. 對於無法回覆有關交貨日期等的詢問，我們深表歉意。</span>
            <span class="text">12.本系統中，產品名稱和獎勵幣是關聯的。 萬一圖片與產品名稱不符，我們將優先考慮產品名稱和獎勵幣，而不是圖片中的產品或獎勵幣。感謝您的體諒。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第14條（信用卡等的使用）</span>
            <span class="text">1 在本網站上，服務使用者可以透過信用卡支付或使用本公司提供的其他服務中指定的方法購買金幣。但是，用於付款的信用卡必須是服務使用者的姓名，並且在付款時必須有效。</span>
            <span class="text">2 使用信用卡付款時，服務利用者應依本公司規定的方法，以服務利用者的名義登記信用卡資料（信用卡種類、卡號、有效期限等，以下統稱為「信用卡資料」）。</span>
            <span class="text">3、因信用卡資訊登記錯誤等對服務使用者造成的任何損失，本公司不承擔任何責任。此外，如果服務使用者因信用卡使用方面的虛假或欺詐而使公司遭受損失，則服務使用者應對公司遭受的任何及全部損失進行賠償。</span>
            <span class="text">4 當使用信用卡支付使用本網站所產生的費用時，本公司應按規定方式向服務利用者用於支付的信用卡請求信用卡公司的批准，如果未獲得批准，則不得進行支付。在此情況下，即使服務利用者遭受損害，本公司也不承擔任何責任。</span>
            <span class="text">5 即使在服務利用者的信用卡付款完成後，如果信用卡公司通知本公司拒絕或暫停使用信用卡，或者如果發現服務利用者在信用卡的使用方面存在撒謊或欺詐行為，則無論何種原因，公司都可以取消服務利用者的所有付款。</span>
            <span class="text">6 服務使用者可以在公司提供的其他服務中購買可用於本服務的金幣，但在這種情況下，他們必須使用與本服務相同的帳戶進行購買，如果使用其他帳戶購買金幣，則他們承認該金幣不會反映在本服務中且無法使用。在此情況下，本公司將不提供任何退款或承擔任何責任。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十五條（與支付機構的關係等）</span>
            <span class="text">1 若服務使用者與本公司在本服務中使用的結算公司或支付機構之間就本服務的收費或其他財務義務發生爭議，則該爭議應由服務使用者與本公司解決，本公司不參與該等爭議且不承擔任何責任。</span>
            <span class="text">2 因服務利用者的原因發生前項糾紛，致使本公司遭受損失時，服務利用者應賠償本公司所遭受的全部損失。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第16條（本服務的停止等）</span>
            <span class="text">有下列情形之一的，本公司可以暫時停止提供全部或部分服務，且不承擔損害賠償或其他義務。</span>
            <span class="text">(1) 對提供本服務的設備進行維護或檢查時。</span>
            <span class="text">(2) 因火災、停電等原因導致本服務的提供中斷時。</span>
            <span class="text">(3) 因地震、火山爆發、洪水、海嘯等天災而導致本服務的提供中斷的情況。</span>
            <span class="text">(4) 因戰爭、動亂、暴動、暴動、勞資糾紛、傳染病蔓延、緊急事態宣言等原因導致本服務的提供中斷時。</span>
            <span class="text">(5) 由於本服務的營運或技術原因，本公司認為有必要暫時延後或停止提供本服務時。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十七條（使用限制等）</span>
            <span class="text">1 若本公司認定服務使用者屬於下列情形之一，本公司可在未事先通知服務使用者的情況下，採取暫停使用本服務或解除服務使用協議等措施（以下簡稱「使用限制措施」）。</span>
            <span class="text">(1) 因服務使用者密碼外洩而導致第三方非法使用本服務，或第三方非法使用我們的其他服務，或有此類風險的。</span>
            <span class="text">(2) 如果確定服務使用者的行為將妨礙我們的業務。</span>
            <span class="text">(3) 如果您擁有多個帳戶（禁止行為）。</span>
            <span class="text">(4) 違反使用條款或有違反使用條款的風險時。</span>
            <span class="text">(5) 除前項外，本公司認為有必要採取限制使用措施的情況。</span>
            <span class="text">2 即使因公司根據第一項採取限制使用措施而對服務利用者造成損害，本公司也不對該損害負責。</span>
            <span class="text">3 如果根據本條解除服務使用合同，服務使用者將失去對公司所欠債務期限的利益，並且必須立即履行對公司的所有債務。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十八條（免責聲明）</span>
            <span class="text">1 除本條款另有規定外，本公司不會對對服務使用者造成的損失進行賠償，且服務使用者不得就該等損失向本公司提出索賠。此外，如果服務使用者因使用或終止使用本服務而對第三方造成損害，則使用者應自行承擔解決該損害的風險，本公司不承擔任何責任。但因本公司故意或重大過失造成損害時，則不在此限。</span>
            <span class="text">2 對於因自然災害、戰爭、騷亂、內亂、火災蔓延引起的火災、水災、法律法規的修改或廢止、停電、政府機關的干預、罷工或其他勞資糾紛、交通事故、傳染病蔓延、緊急狀態宣言的發布或其他不可歸咎於公司的原因而導致的損害或未履行服務使用合同項下的義務的任何其他責任，公司不承擔任何其他責任，公司的義務</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第十九條（服務使用者的通知）</span>
            <span class="text">服務使用者同意公司可以透過以下方式之一通知服務使用者。</span>
            <span class="text">(1) 這將在服務中發布。在這種情況下，對服務使用者的通知將被視為在發佈時已完成。</span>
            <span class="text">(2) 我們會將其發佈在我們的網站上。在這種情況下，對服務使用者的通知將被視為在發佈時已完成。</span>
            <span class="text">(3) 向服務利用者在申請使用時及其後通知本公司的電子郵件地址發送電子郵件。在這種情況下，當電子郵件被傳送到服務使用者的電子郵件地址時，將被視為已完成對服務使用者的通知。</span>
            <span class="text">(4) 此外，我們還將以我們認為適當的任何其他方式這樣做。在這種情況下，對服務利用者的通知將被視為已在本公司在通知中指定的時間完成。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十條（排除反社會勢力）</span>
            <span class="text">服務使用者聲明並保證以下內容：</span>
            <span class="text">（一）申請人過去或將來不得是反社會勢力（包括組織犯罪集團、組織犯罪成員、組織犯罪集團關聯成員、組織犯罪相關企業、企業敲詐勒索者、社會運動往來、政治活動暴徒、特殊情報團夥等，下同），未曾與反社會勢力有過任何業務往來，未曾透過提供資金等行為配合或參與社會勢力與社會勢力有過任何事業的行動。</span>
            <span class="text">（二）不得對公司及其員工進行毆打、傷害、恐嚇、勒索、脅迫等暴力、威脅行為；不得以散佈謠言、誣告等欺詐方式提出超出合理限度的無理要求；不得損害公司及其員工的聲譽或信任；</span>
            <span class="text">(3) 不得做出告知本公司或第三方您是反社會勢力或與反社會勢力有關係等行為。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第21條（服務使用契約等的狀態轉移）</span>
            <span class="text">1 服務使用者不得將服務使用合約下的地位或與服務使用合約相關的權利或義務轉讓、繼承、買賣、變更名稱、設定抵押物等給第三方。</span>
            <span class="text">2 無論以何種方式進行業務轉讓、公司分立、合併等，如果公司將與本服務相關的業務轉讓或繼承給第三方（以下簡稱「業務轉讓等」），公司可以在未徵得服務利用者同意的情況下，將服務使用協議項下的地位、基於服務使用協議的權利和義務以及帳戶資訊處理權限轉讓或繼承給受讓人。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十二條（義務的存續）</span>
            <span class="text">即使服務使用協議終止，服務使用者仍不免除服務使用協議終止前所產生的任何義務。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第23條（條款的變更）</span>
            <span class="text">1 在下列情況下，本公司可以在未事先徵得服務使用者同意的情況下變更本條款。在這種情況下，本公司將提前將修改後的使用條款通知服務使用者。</span>
            <span class="text">(1) 本使用條款的變更符合服務使用者的普遍利益。</span>
            <span class="text">(2) 本使用條款的變更不與服務使用協議的目的相抵觸，且考慮變更的必要性、變更內容的適當性以及與變更相關的其他情況是合理的。</span>
            <span class="text">2 除前項規定外，本公司可在徵得服務使用者的同意後更改本使用條款。</span>
            <span class="text">3 出現下列情形之一的，服務使用者將被視為同意本使用條款的變更。</span>
            <span class="text">(1) 如果公司在變更前至少一個月向服務使用者通知擬變更的使用條款以及變更日期，且服務使用者在使用條款變更之日之前未以書面形式向本公司表示反對變更使用條款。</span>
            <span class="text">(2) 若本公司將使用條款的建議變更以及使用條款的變更日期通知服務使用者，且服務使用者在變更日期之後使用本服務；</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第二十四條（管轄）</span>
            <span class="text">對於服務利用者與本公司之間有關本條款或服務使用協議的任何訴訟，東京地方法院擁有一審專屬管轄權。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">成立於2025年2月28日</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.terms-of-service{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: black;
  .terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .shadow-box {
        justify-content: left;
      }
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: black;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .terms-of-service {
    .scroll-container {
      .shadow-box-title-description {
        .text-container {
          span.text {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
